import { app } from '../../../bootstrap/core';
import { financeBulkImportComponent } from './financeBulkImport.component';
import { FinanceBulkImportService } from './financeBulkImport.service';

app.component('financeBulkImport', financeBulkImportComponent);
app.service('financeBulkImportService', FinanceBulkImportService);
